var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'filter-button',
    'text8',
    _vm.active && 'active',
    _vm.selected && 'selected',
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }